import {
  pathologyAction,
  PathologyActionTypes,
  PathologyParams,
  PathologyPutParams,
} from "../../types/pathology";
import { Dispatch } from "react";
import http from "../../utils/http-common";

export const getMarkupPathology = (region: string) => {
  return async (dispatch: Dispatch<pathologyAction>): Promise<void> => {
    try {
      dispatch({
        type: PathologyActionTypes.GET_MARKUP_PATHOLOGY,
      });

      const response = await http.get(
        `/api/v0.1/upload/annotate?region=${region}`
      );
      dispatch({
        type: PathologyActionTypes.GET_MARKUP_PATHOLOGY_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      alert("Произошла ошибка получения патологии");
      dispatch({
        type: PathologyActionTypes.GET_MARKUP_PATHOLOGY_ERROR,
        payload: "Произошла ошибка получения патологии",
      });
    }
  };
};

export const getPathology = (region: string) => {
  return async (dispatch: Dispatch<pathologyAction>): Promise<void> => {
    try {
      dispatch({
        type: PathologyActionTypes.GET_PATHOLOGY,
      });

      const response = await http.get(`/api/v0.1/validation?region=${region}`);
      dispatch({
        type: PathologyActionTypes.GET_PATHOLOGY_SUCCESS,
        payload: response.data,
      });
    } catch (e) {
      alert("Произошла ошибка получения патологии");
      dispatch({
        type: PathologyActionTypes.GET_PATHOLOGY_ERROR,
        payload: "Произошла ошибка получения патологии",
      });
    }
  };
};

export const saveMarkUpPathology = (
  data: PathologyParams | PathologyPutParams,
  id: string
) => {
  return async (dispatch: Dispatch<pathologyAction>): Promise<void> => {
    try {
      dispatch({
        type: PathologyActionTypes.VALIDATE_PATHOLOGY,
      });

      await http.put(`/api/v0.1/upload/annotate/${id}`, data);
      dispatch({
        type: PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_SUCCESS,
      });
    } catch (e) {
      alert("Произошла ошибка сохранения иследования");
      dispatch({
        type: PathologyActionTypes.SAVE_MARKUP_PATHOLOGY_ERROR,
        payload: "Произошла ошибка сохранения иследования",
      });
    }
  };
};

export const validatePathology = (
  data: PathologyParams | PathologyPutParams,
  id: string
) => {
  return async (dispatch: Dispatch<pathologyAction>): Promise<void> => {
    try {
      dispatch({
        type: PathologyActionTypes.VALIDATE_PATHOLOGY,
      });

      await http.put(`/api/v0.1/validation/${id}`, data);
      dispatch({
        type: PathologyActionTypes.VALIDATE_PATHOLOGY_SUCCESS,
      });
    } catch (e) {
      alert("Произошла ошибка валидации иследования");
      dispatch({
        type: PathologyActionTypes.VALIDATE_PATHOLOGY_ERROR,
        payload: "Произошла ошибка валидации иследования",
      });
    }
  };
};

export const deletePathology = (id: string) => {
  return async (dispatch: Dispatch<pathologyAction>): Promise<void> => {
    try {
      dispatch({
        type: PathologyActionTypes.DELETE_PATHOLOGY,
      });

      await http.delete(`/api/v0.1/validation/${id}`);
      dispatch({
        type: PathologyActionTypes.DELETE_PATHOLOGY_SUCCESS,
      });
    } catch (e) {
      alert("Произошла ошибка удаления иследования");
      dispatch({
        type: PathologyActionTypes.DELETE_PATHOLOGY_ERROR,
        payload: "Произошла ошибка удаления иследования",
      });
    }
  };
};
